import React, { useState } from "react";
import { FaUserShield, FaLock, FaUser, FaEye, FaEyeSlash } from "react-icons/fa";
import { apiService } from "./services/apiService";
import scannerImg from "./scanner_shivaba.jpg"; 
import "./styles/Login.css"; // Import the CSS file

function Login({ onLoginSuccess }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setErrorMessage("");
    setLoading(true);
    apiService.login({ username, password })
      .then((data) => { 
        setLoading(false); 
        onLoginSuccess(data.token, data.roleId, data.clientName); 
      })
      .catch((err) => { 
        setLoading(false); 
        setErrorMessage(err.message || "Invalid credentials."); 
      });
  };

  return (
    <div className="login-wrapper">
      <div className="login-card-container">
        <div className="login-scanner-side">
          <img src={scannerImg} alt="Scanner" className="login-scanner-img" draggable="false" />
        </div>
        <div className="login-details-side">
          <div className="login-header">
            <div className="login-logo-circle"><FaUserShield size={40} color="#1a237e" /></div>
            <h2>Online Institute Management Portal</h2>
            <p>Admin Portal Authentication</p>
          </div>
          
          <form onSubmit={handleSubmit} className="login-form">
            {errorMessage && <div className="login-error-msg">{errorMessage}</div>}
            
            <div className="input-group">
              <label><FaUser className="input-icon" /> Username</label>
              <input type="text" value={username} onChange={(e) => setUsername(e.target.value)} placeholder="Enter your username" required />
            </div>

            <div className="input-group">
              <label><FaLock className="input-icon" /> Password</label>
              <div className="password-input-wrapper">
                <input 
                  type={showPassword ? "text" : "password"} 
                  value={password} 
                  onChange={(e) => setPassword(e.target.value)} 
                  placeholder="Enter your password" 
                  required 
                />
                <button type="button" className="password-toggle-btn" onClick={() => setShowPassword(!showPassword)}>
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
            </div>

            <button type="submit" disabled={loading} className="login-submit-btn">
              {loading ? "Authenticating..." : "Login to Dashboard"}
            </button>

            <div className="login-enquiry-footer">
              <p className="login-enquiry-text">Enquiry Call or WhatsApp : <span>9881950330 OR 9730073355 </span></p>
              
              {/* Added Copyright Footer */}
              <p className="login-copyright-text" style={{ 
                marginTop: "12px", 
                fontSize: "12px", 
                color: "#7a8ba6", 
                textAlign: "center",
                opacity: 0.8 
              }}>
                © {new Date().getFullYear()} Softneil Private Limited. All rights reserved.
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;